var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"value":this.clicked},on:{"click":_vm.item_clicked}},[_c('div',{staticClass:"checkbox",class:{'clicked':this.clicked}}),_c('span',{staticClass:"a",class:{'hide':this.text == ''}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }